import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBTextField, CancelButton, DBDateField, ToolTipBulb } from '_components';
import { getDateMDYYYY } from '_helpers';
import styles from './Common.module.css'
import { OutMeasureDropDown } from './OutMeasureDropDown';
import { SPEECH_OUTCOME_CONSTANTS } from '_constants'
class OutMeasureEntry extends React.Component {

    removeEntry() {
        this.props.removeChildRow(this.props.noteId, 'PTOUTMEASURES', 'OM', this.props.outEntry.OMNO);
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
    }

    objValueChanged() {
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
    }

    objValueChangedClear() {
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
        this.clearFields();
    }


    clearFields() {
        const fieldsToClear = [
            'OMCORELANGSCORE',
            'OMCONSTANTINV',
            'OMPHONOPROCESS',
            'OMSOUNDINWORD',
            'OMSOUNDINSENTENCE',
            'OMEXPRESSIVELAND',
            'OMRECEPTIVELANG',
            'OMSEVERITY',
            'OMSCORE',
            'OMBODYCONTROLRAW',
            'OMBODYCONTROLAGE',
            'OMBODYCONTROLRANK',
            'OMBODYTRANSRAW',
            'OMBODYTRANSAGE',
            'OMBODYTRANSRANK',
            'OMOBJECTCONTROLRAW',
            'OMOBJECTCONTROLAGE',
            'OMOBJECTCONTROLRANK',
            'OMHANDMANCONTROLRAW',
            'OMHANDMANCONTROLAGE',
            'OMHANDMANCONTROLRANK',
            'OMHANDEYECONTROLRAW',
            'OMHANDEYECONTROLAGE',
            'OMHANDEYECONTROLRANK'
        ];

        fieldsToClear.forEach(field => {
            const value = this.props.outEntry[field];
            if (value) {
                this.props.updateBitField(this.props.noteId, 'PTOUTMEASURES', 'OMNO', this.props.outEntry.OMNO, field, null);
            }
        });

        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
    }



    render() {
        let componentToRender;

        switch (true) {
            case this.props.isCelf5 || this.props.isCelfp2:
                componentToRender = (
                    <>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity="PTOUTMEASURES"
                            entityKeyColumn="OMNO"
                            entityKeyValue={this.props.outEntry.OMNO}
                            field="OMCORELANGSCORE"
                            className={styles.score_input}
                            placeholder="Core Language Score"
                            onChange={() => this.objValueChanged()}
                        />
                        <div className={styles.remove_button}>
                            <CancelButton title='Remove' size='extra-small' onClick={() => this.removeEntry()} />
                        </div>
                    </>
                );
                break;

            case this.props.isCaap2:
                componentToRender = (
                    <>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity="PTOUTMEASURES"
                            entityKeyColumn="OMNO"
                            entityKeyValue={this.props.outEntry.OMNO}
                            field="OMCONSTANTINV"
                            className={styles.score_input}
                            placeholder="Consonant Inventory"
                            onChange={() => this.objValueChanged()}
                        />
                        <DBTextField
                            noteId={this.props.noteId}
                            entity="PTOUTMEASURES"
                            entityKeyColumn="OMNO"
                            entityKeyValue={this.props.outEntry.OMNO}
                            field="OMPHONOPROCESS"
                            className={styles.score_input}
                            placeholder="Phonological Processes"
                            onChange={() => this.objValueChanged()}
                        />
                        <div className={styles.remove_button}>
                            <CancelButton title='Remove' size='extra-small' onClick={() => this.removeEntry()} />
                        </div>
                    </>
                );
                break;

            case this.props.isGfta3:
                componentToRender = (
                    <>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity="PTOUTMEASURES"
                            entityKeyColumn="OMNO"
                            entityKeyValue={this.props.outEntry.OMNO}
                            field="OMSOUNDINWORD"
                            className={styles.score_input}
                            placeholder="Sounds-in-words"
                            onChange={() => this.objValueChanged()}
                        />
                        <DBTextField
                            noteId={this.props.noteId}
                            entity="PTOUTMEASURES"
                            entityKeyColumn="OMNO"
                            entityKeyValue={this.props.outEntry.OMNO}
                            field="OMSOUNDINSENTENCE"
                            className={styles.score_input}
                            placeholder="Sounds-in-sentences"
                            onChange={() => this.objValueChanged()}
                        />
                        <div className={styles.remove_button}>
                            <CancelButton title='Remove' size='extra-small' onClick={() => this.removeEntry()} />
                        </div>
                    </>
                );
                break;

            case this.props.isRossettiScale:
                componentToRender = (
                    <>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity="PTOUTMEASURES"
                            entityKeyColumn="OMNO"
                            entityKeyValue={this.props.outEntry.OMNO}
                            field="OMEXPRESSIVELAND"
                            className={styles.score_input}
                            placeholder="Expressive Language"
                            onChange={() => this.objValueChanged()}
                        />
                        <DBTextField
                            noteId={this.props.noteId}
                            entity="PTOUTMEASURES"
                            entityKeyColumn="OMNO"
                            entityKeyValue={this.props.outEntry.OMNO}
                            field="OMRECEPTIVELANG"
                            className={styles.score_input}
                            placeholder="Receptive Language"
                            onChange={() => this.objValueChanged()}
                        />
                        <div className={styles.remove_button}>
                            <CancelButton title='Remove' size='extra-small' onClick={() => this.removeEntry()} />
                        </div>
                    </>
                );
                break;

            case this.props.isFcpR:
                componentToRender = (
                    <>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity="PTOUTMEASURES"
                            entityKeyColumn="OMNO"
                            entityKeyValue={this.props.outEntry.OMNO}
                            field="OMSEVERITY"
                            className={styles.score_input}
                            placeholder="Severity Rating"
                            onChange={() => this.objValueChanged()}
                        />
                        <div className={styles.remove_button}>
                            <CancelButton title='Remove' size='extra-small' onClick={() => this.removeEntry()} />
                        </div>
                    </>
                );
                break;
            case this.props.isPeds && this.props.isPDMS3:
                componentToRender = (<>
                </>);
                break;
            case this.props.isPeds:
                componentToRender = (
                    <>
                        {this.props.isOther &&
                            <div className={styles.dropdown_row}>
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTOUTMEASURES'
                                    entityKeyColumn='OMNO'
                                    entityKeyValue={this.props.outEntry.OMNO}
                                    field='OMNAME'
                                    className={styles.out_measure_other}
                                />
                            </div>
                        }
                        <div className={styles.dropdown_row}>
                            <span className={this.props.scoreReq ? styles.detail_text_row : styles.detail_text_row_not_req}>
                                <span className={styles.score_indent}>
                                    Score:
                                </span>
                            </span>
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTOUTMEASURES'
                                entityKeyColumn='OMNO'
                                entityKeyValue={this.props.outEntry.OMNO}
                                field='OMSCORE'
                                className={this.props.scoreReq ? styles.score_input_large_req : styles.score_input_large}
                                onChange={() => this.objValueChanged()}
                            />
                            <div className={styles.remove_button}>
                                <CancelButton title='Remove' size='extra-small' onClick={() => this.removeEntry()} />
                            </div>
                            <ToolTipBulb uid={'OMNO_' + this.props.outEntry.OMNO} position='right' width={300}>
                                <span>
                                    {(!this.props.masterOutcome || !this.props.masterOutcome.MOUHOVER) &&
                                        <span>Provide outcome details here to support the recommended care</span>
                                    }
                                    {this.props.masterOutcome && this.props.masterOutcome.MOUHOVER &&
                                        <span dangerouslySetInnerHTML={{ __html: this.props.masterOutcome.MOUHOVER }} />
                                    }
                                </span>
                            </ToolTipBulb >
                        </div>
                    </>
                );
                break;

            default:
                componentToRender = (
                    <div className={styles.dropdown_row}>
                        <span className={this.props.scoreReq ? styles.detail_text_row : styles.detail_text_row_not_req}>
                            <span className={styles.score_indent}>
                                Score:
                            </span>
                        </span>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='PTOUTMEASURES'
                            entityKeyColumn='OMNO'
                            entityKeyValue={this.props.outEntry.OMNO}
                            field='OMSCORE'
                            className={this.props.scoreReq ? styles.score_input_large_req : styles.score_input_large}
                            onChange={() => this.objValueChanged()}
                        />
                        <div className={styles.remove_button}>
                            <CancelButton title='Remove' size='extra-small' onClick={() => this.removeEntry()} />
                        </div>
                        <ToolTipBulb uid={'OMNO_' + this.props.outEntry.OMNO} position='right' width={300}>
                            <span>
                                {(!this.props.masterOutcome || !this.props.masterOutcome.MOUHOVER) &&
                                    <span>Provide outcome details here to support the recommended care</span>
                                }
                                {this.props.masterOutcome && this.props.masterOutcome.MOUHOVER &&
                                    <span dangerouslySetInnerHTML={{ __html: this.props.masterOutcome.MOUHOVER }} />
                                }
                            </span>
                        </ToolTipBulb >
                    </div>
                );
                break;
        }

        if (this.props.outEntry.OMFOTOFANO !== null) {
            return (
                <div className={styles.dropdown_row}>
                    <span className={styles.out_measure}>{this.props.outEntry.OMNAME}</span>
                    <span className={styles.date}>{getDateMDYYYY(this.props.outEntry.OMDATE)}</span>
                    <span className={styles.score}>{this.props.outEntry.OMSCORE}</span>
                </div>

            );
        } else {
            return (
                <div>
                    <div className={styles.dropdown_row}>
                        <OutMeasureDropDown
                            noteId={this.props.noteId}
                            entity='PTOUTMEASURES'
                            entityKeyColumn='OMNO'
                            entityKeyValue={this.props.outEntry.OMNO}
                            field='OMNAME'
                            className={styles.out_measure_dropdown}
                            onChange={() => this.objValueChangedClear()}
                            epno={this.props.epno}
                        />
                        <DBDateField
                            noteId={this.props.noteId}
                            entity='PTOUTMEASURES'
                            entityKeyColumn='OMNO'
                            entityKeyValue={this.props.outEntry.OMNO}
                            field='OMDATE'
                            maxDate={new Date()}
                            className={styles.date_picker}
                            onChange={() => this.objValueChanged()}
                        />
                        {this.props.isOther && !this.props.isPeds &&
                            <div className={styles.dropdown_row}>
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTOUTMEASURES'
                                    entityKeyColumn='OMNO'
                                    entityKeyValue={this.props.outEntry.OMNO}
                                    field='OMNAME'
                                    className={styles.out_measure_other}
                                />
                            </div>
                        }

                        {componentToRender}
                    </div>
                    {this.props.isPDMS3 &&
                        <>
                            <div className={styles.dropdown_row}>
                                <span className={styles.header_spacer}>
                                </span>
                                <span className={styles.raw_score_header}>Raw score</span>
                                <span className={styles.age_equivalence_header}>Age Equivalence</span>
                                <span className={styles.percentile_rank_header}>Percentile rank</span>
                            </div>
                            <div className={styles.dropdown_row}>
                                <div className={styles.cell_wrapper}>
                                    <span className={styles.detail_text}>
                                        Body control
                                    </span>
                                </div>                                <div className={styles.cell_wrapper}>

                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMBODYCONTROLRAW'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                                <div className={styles.cell_wrapper}>

                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMBODYCONTROLAGE'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMBODYCONTROLRANK'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                            </div>
                            <div className={styles.dropdown_row}>
                                <div className={styles.cell_wrapper}>
                                    <span className={styles.detail_text}>
                                        Body transport
                                    </span>
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMBODYTRANSRAW'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMBODYTRANSAGE'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMBODYTRANSRANK'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                            </div>
                            <div className={styles.dropdown_row}>
                                <div className={styles.cell_wrapper}>
                                    <span className={styles.detail_text}>
                                        Object control
                                    </span>
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMOBJECTCONTROLRAW'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMOBJECTCONTROLAGE'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMOBJECTCONTROLRANK'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                            </div>
                            <div className={styles.dropdown_row}>
                                <div className={styles.cell_wrapper}>
                                    <span className={styles.detail_text}>
                                        Hand manipulation
                                    </span>
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMHANDMANCONTROLRAW'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMHANDMANCONTROLAGE'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMHANDMANCONTROLRANK'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                            </div>
                            <div className={styles.dropdown_row}>
                                <div className={styles.cell_wrapper}>
                                    <span className={styles.detail_text}>
                                        Eye-hand coordination
                                    </span>
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMHANDEYECONTROLRAW'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMHANDEYECONTROLAGE'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                                <div className={styles.cell_wrapper}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTOUTMEASURES'
                                        entityKeyColumn='OMNO'
                                        entityKeyValue={this.props.outEntry.OMNO}
                                        field='OMHANDEYECONTROLRANK'
                                        className={styles.pdms3_text}
                                    />
                                </div>
                            </div>
                        </>
                    }
                </div>
            );
        }
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let objUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTOBJECTIVEUPDATED : true;
    let masterOutcome = state.entities.masterData.PTMASTEROUTCOMES[state.entities.notes.PTOUTMEASURES[ownprops.id].OMMOUNO];
    let isOther = masterOutcome && masterOutcome.MOUNAME === 'Other' ? true : false;
    let isPDMS3 = masterOutcome && masterOutcome.MOUNAME === 'Peabody (PDMS3)' ? true : false;
    let isCelf5 = masterOutcome && masterOutcome.MOUNAME === SPEECH_OUTCOME_CONSTANTS.CELF_5;
    let isCelfp2 = masterOutcome && masterOutcome.MOUNAME === SPEECH_OUTCOME_CONSTANTS.CELFP_2;
    let isCaap2 = masterOutcome && masterOutcome.MOUNAME === SPEECH_OUTCOME_CONSTANTS.CAAP_2;
    let isGfta3 = masterOutcome && masterOutcome.MOUNAME === SPEECH_OUTCOME_CONSTANTS.GFTA_3;
    let isRossettiScale = masterOutcome && masterOutcome.MOUNAME === SPEECH_OUTCOME_CONSTANTS.ROSSETTI_SCALE;
    let isFcpR = masterOutcome && masterOutcome.MOUNAME === SPEECH_OUTCOME_CONSTANTS.FCP_R;
    let epno = ownprops.epno;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isPeds = state.entities.admissions[epno].isPeds && isPedsEnabled;
    let scoreReq = false;

    if (state.entities.notes.PTOUTMEASURES[ownprops.id].OMNAME !== null && state.entities.notes.PTOUTMEASURES[ownprops.id].OMSCORE === null) {
        scoreReq = true;
    }

    return {
        noteId,
        outEntry: state.entities.notes.PTOUTMEASURES[ownprops.id],
        masterOutcome,
        objUpdated,
        isOther,
        epno,
        isPDMS3,
        isCelf5,
        isCelfp2,
        isCaap2,
        isGfta3,
        isRossettiScale,
        isFcpR,
        isPeds,
        scoreReq
    };
}

const connectedOutMeasureEntry = connect(mapStateToProps, mapDispatchToProps)(OutMeasureEntry);
export { connectedOutMeasureEntry as OutMeasureEntry };


